import { Button } from '~/components/ui/Button';

interface DowngradeWarningProps {
  type: 'individual' | 'team';
  onRenewClick: () => void;
}

export const DowngradeWarning = ({ type = 'individual', onRenewClick }: DowngradeWarningProps) => {
  return (
    <div className="lg:max-w-60% sm:justify-self-end text-bolt-ds-textSecondary text-xs sm:text-end sm:col-start-1 sm:col-end-6 text-balance">
      Your subscription is being {type === 'individual' ? 'downgraded to Free' : 'canceled'}. You need to{' '}
      <Button variant="link-color" className="inline-flex" size="sm" onClick={onRenewClick}>
        {type === 'individual' ? 'cancel downgrade' : 'renew subscription'}
      </Button>{' '}
      to upgrade your plan
    </div>
  );
};
